/**
 * 멤버 관리 API
 * OpenAPI Generator로 생성된 타입을 사용하며, 기존 Axios 인스턴스와 통합
 */
export class MemberService {
    constructor(axiosInstance) {
        Object.defineProperty(this, "axios", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.axios = axiosInstance;
    }
    /**
     * 회원 전화번호 변경
     * 회원 전화번호를 변경한다.
     * @returns 회원 전화번호 변경 결과
     */
    updatePhone(request) {
        return this.axios.put(`/main/v1/members/phone`, request);
    }
    /**
     * 마케팅 동의 변경
     * 회원의 마케팅(광고성 정보) 수신 동의 여부를 변경한다.
     * @returns 마케팅 동의 변경 결과
     */
    updateMarketingAgreement(request) {
        return this.axios.put(`/main/v1/members/marketing-agreement`, request);
    }
    /**
     * 회원 주소정보 변경
     * 회원 주소정보를 변경한다.
     * @returns 회원 주소정보 변경 결과
     */
    updateAddress(request) {
        return this.axios.put(`/main/v1/members/address`, request);
    }
    /**
     * 비밀번호 변경
     * 인증이 완료된 사용자의 비밀번호를 새로운 비밀번호로 변경한다. 이메일 인증이 완료되지 않은 경우 오류를 반환한다.
     * @returns 비밀번호 변경 결과
     */
    changePassword(request) {
        return this.axios.post(`/main/v1/members/password/change`, request);
    }
    /**
     * 개인회원 가입
     * 새로운 개인회원을 등록한다.
  
  선택 파일:
  - idCard: 신분증 (미제출 시 준회원으로 가입)
  
  - additionalIdDocument: 주민등록초본 or 관공서 납부영수증 (선택사항)
       - swagger 내부에서 테스트 시 파일이 없다면, Send empty value 를 해제하고 테스트해야 한다.
  
     * @returns 개인회원 가입 결과
     */
    joinIndividual(request) {
        // 중첩 구조 multipart: 내부 객체를 JSON으로 변환
        const formData = {
            individualMember: JSON.stringify(request.individualMember),
            idCard: request.idCard,
        };
        if (request.additionalIdDocument) {
            formData.additionalIdDocument = request.additionalIdDocument;
        }
        return this.axios.postForm(`/main/v1/members/join/individual`, formData);
    }
    /**
     * 법인회원 가입
     * 새로운 법인회원을 등록한다.
  
  필수 파일:
  - businessRegistration: 사업자등록증명원 (필수)
  
  - corporateRepresentative: 법인 대표 초본 (필수)
  
  - billPaymentCorporate: 법인명 공과금 납부서 (필수)
  
  - shareholderRegister: 주주 명부 (필수)
  
  - corporateRepresentativePassport: 법인대표 여권 사본 (필수)
  
  선택 파일:
  - additionalCorporateRepresentativePassport: 다른 법인 대표 여권 사본 (선택사항)
       - swagger 내부에서 테스트 시 파일이 없다면, Send empty value 를 해제하고 테스트해야 한다.
  
     * @returns 법인회원 가입 결과
     */
    joinCorporate(request) {
        // 중첩 구조 multipart: 내부 객체를 JSON으로 변환
        const formData = {
            corporateMember: JSON.stringify(request.corporateMember),
            businessRegistration: request.businessRegistration,
            corporateRepresentative: request.corporateRepresentative,
            billPaymentCorporate: request.billPaymentCorporate,
            shareholderRegister: request.shareholderRegister,
            corporateRepresentativePassport: request.corporateRepresentativePassport,
        };
        if (request.additionalCorporateRepresentativePassport?.length) {
            formData.additionalCorporateRepresentativePassport =
                request.additionalCorporateRepresentativePassport;
        }
        return this.axios.postForm(`/main/v1/members/join/corporate`, formData);
    }
    /**
     * 아이디 찾기
     * SMS 인증이 완료된 사용자의 마스킹된 이메일을 반환한다. SMS 인증이 완료되지 않은 경우 오류를 반환한다.
     * @returns 아이디 찾기 결과
     */
    findId(request) {
        return this.axios.post(`/main/v1/members/find-id`, request);
    }
    /**
     * 개인회원 서류 제출
     * 준회원(서류 미제출) 상태의 개인회원이 서류를 제출한다.
  
  서류 제출 완료 시 KYC 심사 중(IN_PROGRESS) 상태로 변경된다.
  
  이미 서류를 제출한 회원은 다시 제출할 수 없다.
  
     * @returns 개인회원 서류 제출 결과
     */
    submitIndividualDocuments(request) {
        return this.axios.postForm(`/main/v1/members/documents/individual`, request);
    }
    /**
     * 법인회원 서류 제출
     * 준회원(서류 미제출) 상태의 법인회원이 서류를 제출한다.
  
  서류 제출 완료 시 KYC 심사 중(IN_PROGRESS) 상태로 변경된다.
  
  이미 서류를 제출한 회원은 다시 제출할 수 없다.
  
     * @returns 법인회원 서류 제출 결과
     */
    submitCorporateDocuments(request) {
        return this.axios.postForm(`/main/v1/members/documents/corporate`, request);
    }
    /**
     * 회원정보 조회
     * 회원정보(이름, 전화번호, 마지막 로그인 시간) 를 반환한다.
     * @returns 회원정보 조회  결과
     */
    getInfo() {
        return this.axios.get(`/main/v1/members/info`);
    }
    /**
     * 회원 로그인 이력 조회
     * 회원의 로그인 이력 및 로그아웃 이력 정보를 반환한다.
     * @param request - 회원 로그인 이력 조회 요청 데이터
     * @returns 회원 로그인 이력 조회 결과
     */
    getAccessHistory(request) {
        return this.axios.get(`/main/v1/members/access-history`, {
            params: request,
        });
    }
}
//# sourceMappingURL=member.service.js.map